var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  border-radius: 15px;\n  color: #fff;\n  padding: 4px 15px;\n  box-shadow: 0 5px 10px 0 rgba(180, 151, 90, 0.15);\n  width: auto;\n  margin: 5px;\n  font-family: ', ';\n  font-size: 10px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #ffffff;\n  white-space: nowrap;\n'], ['\n  background-color: ', ';\n  border-radius: 15px;\n  color: #fff;\n  padding: 4px 15px;\n  box-shadow: 0 5px 10px 0 rgba(180, 151, 90, 0.15);\n  width: auto;\n  margin: 5px;\n  font-family: ', ';\n  font-size: 10px;\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #ffffff;\n  white-space: nowrap;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { grey } from '../assets/colors';
import { Montserrat } from '../assets/fonts';

var Badge = styled.span(_templateObject, function (props) {
  return props.color || grey;
}, Montserrat);
Badge.displayName = 'Badge';

Badge.propTypes = {
  color: PropTypes.string
};

export default Badge;